var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section-related',{attrs:{"title":"Also Known As: ","items":_vm.aliases,"prerender-list-name":"aliases","is-template":_vm.isTemplate}})}
var staticRenderFns = []

export { render, staticRenderFns }